import React from 'react'
import { Button } from '../../../../ui/Button'

interface ExistingAppointmentStateProps {
  onContinue: () => void
}

export const ExistingAppointmentState: React.FC<ExistingAppointmentStateProps> = ({
  onContinue
}) => {
  return (
    <div className="text-center py-12">
      <div className="mb-8">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg
            className="w-10 h-10 text-green-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Ya tienes una cita agendada
        </h2>
        <p className="text-gray-600">
          Tu cita de verificación ya está programada. Recibirás un
          recordatorio por correo electrónico.
        </p>
      </div>

      <div className="flex justify-center gap-4">
        <Button onClick={onContinue} variant="primary">
          Continuar con el proceso
        </Button>
      </div>
    </div>
  )
}